var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showDialog
        ? _c("ModalFullScreen", {
            attrs: { title: _vm.modalTitle },
            on: { close: _vm.closeModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "titleLine",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-2 mr-5" },
                        [
                          _c("span", { staticClass: "text-gray-700" }, [
                            _vm._v("Active"),
                          ]),
                          _c("SwitchComponent", {
                            attrs: {
                              isOn: _vm.posting.active,
                              onColor: "#47da47",
                            },
                            on: { toggle: _vm.toggleActive },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.submit.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("ValidationObserver", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ invalid, dirty }) {
                                    return [
                                      _c("p", { staticClass: "text-sm" }, [
                                        _vm._v("Post To"),
                                      ]),
                                      _c(
                                        "ModalContent",
                                        {
                                          attrs: {
                                            actionClasses: "justify-end",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "actions",
                                                fn: function () {
                                                  return [
                                                    _c("UIButton", {
                                                      staticClass: "mr-3",
                                                      attrs: {
                                                        variant: "outline",
                                                        buttonText: "Cancel",
                                                        id: "cancelPosting",
                                                        buttonClasses:
                                                          "customButtonCard",
                                                      },
                                                      on: {
                                                        click: _vm.closeModal,
                                                      },
                                                    }),
                                                    _vm.data
                                                      ? _c("UIButton", {
                                                          attrs: {
                                                            type: "submit",
                                                            variant: "black",
                                                            id: "submiytPosting",
                                                            disabled: invalid,
                                                            buttonText:
                                                              "Update",
                                                            buttonClasses:
                                                              "customButtonCard",
                                                          },
                                                        })
                                                      : _c("UIButton", {
                                                          attrs: {
                                                            type: "submit",
                                                            variant: "black",
                                                            id: "createNewPostingJob",
                                                            disabled:
                                                              invalid || !dirty,
                                                            buttonText:
                                                              "Create",
                                                            buttonClasses:
                                                              "customButtonCard",
                                                          },
                                                        }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("CheckboxButtonGroupV2", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              options: _vm.publicTypeOptions,
                                              name: "public",
                                              color: "black",
                                            },
                                            model: {
                                              value: _vm.posting.public,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.posting,
                                                  "public",
                                                  $$v
                                                )
                                              },
                                              expression: "posting.public",
                                            },
                                          }),
                                          _c("ValidationProvider", {
                                            attrs: {
                                              rules: "required_field|max:37",
                                              name: "Job title",
                                              immediate: _vm.isEditing,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        staticClass: "mb-4",
                                                        attrs: {
                                                          errors: errors,
                                                          inputClass:
                                                            "fullwidthInput",
                                                          name: "job_title",
                                                          placeholder:
                                                            "Enter title",
                                                          isIcon: false,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "title",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-2",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "required-icon",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "*"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " Job Title "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.posting
                                                              .job_title,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.posting,
                                                              "job_title",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "posting.job_title",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                title: "Country",
                                                inputClass: "fullwidthInput",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "title",
                                                    fn: function () {
                                                      return [
                                                        _c("p", [
                                                          _vm._v("Country"),
                                                        ]),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("ProfileCountrySelect", {
                                                staticClass: "mb-4",
                                                attrs: {
                                                  getcontainerStyle:
                                                    "customFullWidthInput",
                                                },
                                                model: {
                                                  value: _vm.posting.country,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "country",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "posting.country",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("RegionInput", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              countries: _vm.posting.country,
                                              shouldFullWidth:
                                                "customFullWidthInput",
                                              getcontainerStyle:
                                                "customFullWidthInput",
                                              title: "Region",
                                              isIcon: false,
                                            },
                                            model: {
                                              value: _vm.posting.state,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.posting,
                                                  "state",
                                                  $$v
                                                )
                                              },
                                              expression: "posting.state",
                                            },
                                          }),
                                          _c("ValidationProvider", {
                                            attrs: {
                                              name: "City",
                                              rules: "name_with_spaces",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        staticClass: "mb-4",
                                                        attrs: {
                                                          title: "City",
                                                          placeholder:
                                                            "Enter city",
                                                          errors: errors,
                                                          isIcon: false,
                                                          inputClass:
                                                            "fullwidthInput",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.posting.city,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.posting,
                                                              "city",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "posting.city",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm.canEditManager
                                            ? _c("ValidationProvider", {
                                                attrs: { name: "manager" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                        failed,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "FormGroup",
                                                            {
                                                              staticClass:
                                                                "mb-4",
                                                              attrs: {
                                                                errors: errors,
                                                                name: "manager",
                                                                title:
                                                                  "Manager",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "ManagersMultiselect",
                                                                {
                                                                  staticClass:
                                                                    "mb-4",
                                                                  attrs: {
                                                                    value:
                                                                      _vm.managersIds,
                                                                    invalid:
                                                                      failed,
                                                                    multiple: false,
                                                                    placeholder:
                                                                      "Select a manager",
                                                                    title:
                                                                      "Manager",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.handleManagerInput,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "flex py-3" },
                                            [
                                              _c("ValidationProvider", {
                                                class: ["w-full"],
                                                attrs: {
                                                  name: "Employment Type",
                                                  rules: "required_field",
                                                  immediate: _vm.isEditing,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                        failed,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "FormGroup",
                                                            {
                                                              staticClass:
                                                                "mb-4",
                                                              attrs: {
                                                                errors: errors,
                                                                title: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "title",
                                                                      fn: function () {
                                                                        return [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "mb-2",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "required-icon",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "*"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " Employment Type"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                      proxy: true,
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c(
                                                                "EmploymentTypeSelect",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .posting
                                                                        .employment_type,
                                                                    invalid:
                                                                      failed,
                                                                    multiple: false,
                                                                    getcontainerStyle:
                                                                      "customFullWidthInput",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.handleEmploymentTypeInput,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.isContractEmployment
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "flex flex-col",
                                                },
                                                [
                                                  _vm.isDurationInterval
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex justify-between w-full",
                                                          },
                                                          [
                                                            _c(
                                                              "ValidationProvider",
                                                              {
                                                                staticClass:
                                                                  "w-6/12 mr-3",
                                                                attrs: {
                                                                  vid: "start_date",
                                                                  rules:
                                                                    "required_field|noPastDate",
                                                                  name: "Start Date",
                                                                  immediate:
                                                                    _vm.isEditing,
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          errors,
                                                                          failed,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "FormGroup",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-4",
                                                                                attrs:
                                                                                  {
                                                                                    errors:
                                                                                      errors,
                                                                                    name: "start_date",
                                                                                  },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "title",
                                                                                        fn: function () {
                                                                                          return [
                                                                                            _c(
                                                                                              "p",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mb-2",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "required-icon",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "*"
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " Start Date"
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                        proxy: true,
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "FormDatepicker",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        name: "start date",
                                                                                        invalid:
                                                                                          failed,
                                                                                        isCalenderIcon: true,
                                                                                        heightClass:
                                                                                          "datePickerHeight",
                                                                                        calendarClass:
                                                                                          "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                                                                                      },
                                                                                    scopedSlots:
                                                                                      _vm._u(
                                                                                        [
                                                                                          {
                                                                                            key: "calendericon",
                                                                                            fn: function ({
                                                                                              cls,
                                                                                            }) {
                                                                                              return [
                                                                                                _c(
                                                                                                  "CalenderIcon",
                                                                                                  {
                                                                                                    class:
                                                                                                      cls,
                                                                                                  }
                                                                                                ),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                        ],
                                                                                        null,
                                                                                        true
                                                                                      ),
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .posting
                                                                                            .start_date,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm.posting,
                                                                                              "start_date",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "posting.start_date",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                            _c(
                                                              "ValidationProvider",
                                                              {
                                                                staticClass:
                                                                  "w-6/12",
                                                                attrs: {
                                                                  rules:
                                                                    "noBeforeDate:@start_date,@ongoing|required_field",
                                                                  name: "End Date",
                                                                  immediate:
                                                                    _vm.isEditing,
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          errors,
                                                                          failed,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "FormGroup",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-4",
                                                                                attrs:
                                                                                  {
                                                                                    errors:
                                                                                      errors,
                                                                                    name: "end_date",
                                                                                  },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "title",
                                                                                        fn: function () {
                                                                                          return [
                                                                                            _c(
                                                                                              "p",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mb-2",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "required-icon",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "*"
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  "End Date"
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                        proxy: true,
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "FormDatepicker",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        name: "end_date",
                                                                                        calendarClass:
                                                                                          "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                                                                                        invalid:
                                                                                          failed,
                                                                                        isCalenderIcon: true,
                                                                                        heightClass:
                                                                                          "datePickerHeight",
                                                                                      },
                                                                                    scopedSlots:
                                                                                      _vm._u(
                                                                                        [
                                                                                          {
                                                                                            key: "calendericon",
                                                                                            fn: function ({
                                                                                              cls,
                                                                                            }) {
                                                                                              return [
                                                                                                _c(
                                                                                                  "CalenderIcon",
                                                                                                  {
                                                                                                    class:
                                                                                                      cls,
                                                                                                  }
                                                                                                ),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                        ],
                                                                                        null,
                                                                                        true
                                                                                      ),
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .posting
                                                                                            .end_date,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm.posting,
                                                                                              "end_date",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "posting.end_date",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "flex",
                                                          },
                                                          [
                                                            _c(
                                                              "ValidationProvider",
                                                              {
                                                                staticClass:
                                                                  "w-full",
                                                                attrs: {
                                                                  name: "Duration",
                                                                  rules:
                                                                    "required|min_value:0",
                                                                  vid: "duration",
                                                                  immediate:
                                                                    _vm.isEditing,
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          errors,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "FormGroup",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-4",
                                                                                attrs:
                                                                                  {
                                                                                    errors:
                                                                                      errors,
                                                                                    name: "duration",
                                                                                    input_wrapper_classes:
                                                                                      "flex items-center gap-2",
                                                                                  },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "title",
                                                                                        fn: function () {
                                                                                          return [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "required-icon",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "*"
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " Duration (" +
                                                                                                _vm._s(
                                                                                                  _vm
                                                                                                    .posting
                                                                                                    .durationUnit
                                                                                                ) +
                                                                                                ") "
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                        proxy: true,
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "FormInput",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        type: "number",
                                                                                        placeholder:
                                                                                          "duration",
                                                                                      },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .posting
                                                                                            .duration,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm.posting,
                                                                                              "duration",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "posting.duration",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "flex items-center",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "RadioButtonGroup",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            parentClass:
                                                                                              "h-10 flex items-center",
                                                                                            options:
                                                                                              _vm.durationUnitOptions,
                                                                                            name: "durationUnit",
                                                                                            bgCheckColor:
                                                                                              "#f2b705",
                                                                                            labelClass:
                                                                                              "bg-job_posting_label",
                                                                                          },
                                                                                        model:
                                                                                          {
                                                                                            value:
                                                                                              _vm
                                                                                                .posting
                                                                                                .durationUnit,
                                                                                            callback:
                                                                                              function (
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.$set(
                                                                                                  _vm.posting,
                                                                                                  "durationUnit",
                                                                                                  $$v
                                                                                                )
                                                                                              },
                                                                                            expression:
                                                                                              "posting.durationUnit",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                  _vm.isContractEmployment
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "w-full items-center flex pb-2",
                                                        },
                                                        [
                                                          _c(
                                                            "RadioButtonGroupV2",
                                                            {
                                                              attrs: {
                                                                options:
                                                                  _vm.durationTypeOptions,
                                                                name: "durationType",
                                                                color: "black",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.posting
                                                                    .duration_type,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.posting,
                                                                      "duration_type",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "posting.duration_type",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "pt-1 mb-2",
                                              attrs: { title: "Industries" },
                                            },
                                            [
                                              _c("IndustriesMultiselect", {
                                                attrs: {
                                                  multiple: true,
                                                  limit: 10,
                                                  max: 10,
                                                  getParentcontainerStyle:
                                                    "customWidthInput",
                                                },
                                                model: {
                                                  value: _vm.posting.industries,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "industries",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "posting.industries",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "py-2 mb-2",
                                              attrs: { title: "Skills" },
                                            },
                                            [
                                              _c("SkillsMultiselect", {
                                                attrs: {
                                                  multiple: true,
                                                  limit: 10,
                                                  max: 10,
                                                  getParentStyle:
                                                    "customWidthInput",
                                                },
                                                model: {
                                                  value: _vm.posting.skillsIds,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "skillsIds",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "posting.skillsIds",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "mb-2",
                                              attrs: { title: "Tags" },
                                            },
                                            [
                                              _c("CustomTagsMultiselect", {
                                                attrs: {
                                                  previouslyChosenTagsIds:
                                                    _vm.posting.tagsIds,
                                                  getParentcontainerStyle:
                                                    "customWidthInput",
                                                  max: 10,
                                                },
                                                on: {
                                                  tagsListUpdated:
                                                    _vm.updateTags,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "pt-2 mb-2 flex items-center gap-1 font-normal",
                                            },
                                            [
                                              _vm._v("Position Budget "),
                                              _c(
                                                "Tooltip",
                                                {
                                                  staticClass:
                                                    "flex items-center ml-1 z-[100] b-tooltipZ",
                                                  attrs: {
                                                    variant:
                                                      _vm.TooltipVariants.DARK,
                                                    title:
                                                      "The Position Budget pertains to the amount of compensation the Resource will receive for this role",
                                                    tooltipClasses:
                                                      "contrcAligment text-sm",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "inline-block",
                                                    },
                                                    [_c("InfoIcon")],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-gray-400 text-sm flex items-center gap-1",
                                                },
                                                [_vm._v("(Optional) ")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex justify-between gap-7",
                                            },
                                            [
                                              _c("ValidationProvider", {
                                                ref: "minBudgetValidator",
                                                staticClass: "w-full",
                                                attrs: {
                                                  rules:
                                                    "noSmaller:@max_budget|max:11",
                                                  name: "Minimum budget",
                                                  delay: "1000",
                                                  vid: "min_budget",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                        failed,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "FormGroup",
                                                            {
                                                              staticClass:
                                                                "mb-4",
                                                              attrs: {
                                                                errors: errors,
                                                                id: "min_rate",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "FormInputGroup",
                                                                {
                                                                  attrs: {
                                                                    invalid:
                                                                      failed,
                                                                    type: "number",
                                                                    placeholder:
                                                                      "Min",
                                                                    inputClasses:
                                                                      "pl-2 w-full rounded-m",
                                                                    suffix: "$",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .posting
                                                                        .min_rate,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.posting,
                                                                          "min_rate",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "posting.min_rate",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("ValidationProvider", {
                                                ref: "maxBudgetValidator",
                                                staticClass: "w-full",
                                                attrs: {
                                                  name: "Maximum budget",
                                                  vid: "max_rate",
                                                  rules:
                                                    "noBigger:@min_budget|max:11",
                                                  delay: "1000",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                        failed,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "FormGroup",
                                                            {
                                                              staticClass:
                                                                "mb-4",
                                                              attrs: {
                                                                errors: errors,
                                                                id: "max_budget",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "FormInputGroup",
                                                                {
                                                                  attrs: {
                                                                    invalid:
                                                                      failed,
                                                                    type: "number",
                                                                    placeholder:
                                                                      "Max",
                                                                    inputClasses:
                                                                      "pl-2 w-full",
                                                                    suffix: "$",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .posting
                                                                        .max_rate,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.posting,
                                                                          "max_rate",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "posting.max_rate",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "FormGroup",
                                            { attrs: { title: "Description" } },
                                            [
                                              _c("FormTextarea", {
                                                attrs: {
                                                  rows: 3,
                                                  name: "description",
                                                  placeholder:
                                                    "Describe the job posting",
                                                  customBorderClass:
                                                    "borderTen",
                                                },
                                                model: {
                                                  value:
                                                    _vm.posting.description,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "description",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "posting.description",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3445686919
                            ),
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              616291466
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }